export const logo = [
  "608 134",
  `<title>TeerApp logo</title>
   <svg viewBox="0 0 2400 512">
      <path
         id="path10"
         class="ci-primary"
         d="M 453.122,79.012 A 128,128 0 0 0 272.035,79.08 l -15.511,15.7 -15.382,-15.666 -0.1,-0.1 a 128,128 0 0 0 -181.02,0 l -6.91,6.91 a 128,128 0 0 0 0,181.019 l 182.373,182.371 20.595,21.578 0.491,-0.492 0.533,0.533 L 276.4,450.574 460.032,266.94 a 128.147,128.147 0 0 0 0,-181.019 z M 437.4,244.313 256.571,425.146 75.738,244.313 a 96,96 0 0 1 0,-135.764 l 6.911,-6.91 a 96,96 0 0 1 135.713,-0.051 l 38.093,38.787 38.274,-38.736 a 96,96 0 0 1 135.765,0 l 6.91,6.909 A 96.11,96.11 0 0 1 437.4,244.313 Z"
         fill="var(--ci-primary-color, currentColor)" />
      <text
         id="text22"
         y="406.013"
         x="586.71121"
         class="teer-logo"
         xml:space="preserve">
          <tspan
            class="text"
            dx="-10.98"
            y="406.013"
            x="586.71121"
            id="tspan20">TeerApp</tspan>
      </text>
   </svg>
`,
];
